exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-treeselect__control{font-size:.875rem!important}.invoices-table{font-size:9pt}.invoices-table .invoices-thumbs{width:80px;max-height:80px}.invoices-table .invoices-table-style-actions .actions-icons{text-align:center}.invoices-table .invoices-table-style-datetime{width:110px}.invoices-table .invoices-table-style-datetime .actions-icons{text-align:center}", ""]);

// exports
